/*
 * VTee ヒーロー スライドショー: 無限ループ + 1枚ずつスワイプ
 * ─ Dawn の slideshow-component(ネイティブ横スクロール)を、transform ベースの
 *   無限カルーセルに置き換える(先頭/末尾にクローンを足し、末尾→先頭が「前進」に
 *   見えるようシームレスにループ)。
 * ─ スワイプは 1 回につき 1 枚。しきい値未満は元の位置に戻す。
 * ─ ドット(.slider-counter__link)クリック・矢印(.slider-button--prev/next)も駆動。
 * ─ JS 非実行時は CSS の overflow-x:auto によるネイティブスワイプにフォールバック。
 *
 * 対象: slideshow-component.vtee-hero
 *   ビューポート = component 自身(overflow:hidden)
 *   トラック     = .slideshow(.vtee-hb) を translateX
 *   スライド     = .slideshow__slide(flex 0 0 100%)
 *   コントロール = component 直下の絶対配置要素(トラック外なので transform の影響を受けない)
 */
(function () {
  'use strict';

  function initHeroCarousel(comp) {
    if (comp.dataset.vteeCarousel === '1') return;
    var track = comp.querySelector('.slideshow.vtee-hb') || comp.querySelector('.slideshow');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll(':scope > .slideshow__slide'));
    if (slides.length < 2) return;
    comp.dataset.vteeCarousel = '1';

    var realCount = slides.length;

    // ─ クローン生成(先頭を末尾へ、末尾を先頭へ)。id は残す(#Slide-N のオーバーレイCSSを効かせるため)
    var firstClone = slides[0].cloneNode(true);
    var lastClone = slides[realCount - 1].cloneNode(true);
    [firstClone, lastClone].forEach(function (c) {
      c.setAttribute('aria-hidden', 'true');
      c.setAttribute('data-vtee-clone', '1');
      Array.prototype.forEach.call(c.querySelectorAll('a, button, [tabindex]'), function (el) {
        el.setAttribute('tabindex', '-1');
      });
    });
    track.appendChild(firstClone);
    track.insertBefore(lastClone, slides[0]);

    comp.classList.add('is-vtee-carousel');

    var index = 1; // 実スライド0番は、先頭に足したクローンの次(DOM位置1)から始まる
    var slideW = 0;
    var animating = false;
    var animTimer = null;

    var dots = Array.prototype.slice.call(comp.querySelectorAll('.slider-counter__link'));
    var prevBtn = comp.querySelector('.slider-button--prev');
    var nextBtn = comp.querySelector('.slider-button--next');

    function measure() { slideW = comp.clientWidth; }

    function setX(animate) {
      track.style.transition = animate
        ? 'transform 0.45s cubic-bezier(0.22, 0.61, 0.36, 1)'
        : 'none';
      track.style.transform = 'translateX(' + (-index * slideW) + 'px)';
      if (!animate) { void track.offsetWidth; } // reflow を強制して次のアニメを確実に
    }

    function realIndex() {
      var r = (index - 1) % realCount;
      if (r < 0) r += realCount;
      return r;
    }

    function syncUI() {
      var ri = realIndex();
      dots.forEach(function (d, i) {
        var on = i === ri;
        d.classList.toggle('slider-counter__link--active', on);
        if (on) d.setAttribute('aria-current', 'true'); else d.removeAttribute('aria-current');
      });
      var reals = track.querySelectorAll('.slideshow__slide:not([data-vtee-clone])');
      Array.prototype.forEach.call(reals, function (s, i) {
        var active = i === ri;
        s.setAttribute('aria-hidden', active ? 'false' : 'true');
        Array.prototype.forEach.call(s.querySelectorAll('a, button'), function (el) {
          if (active) el.removeAttribute('tabindex'); else el.setAttribute('tabindex', '-1');
        });
      });
    }

    function clearAnim() { animating = false; if (animTimer) { clearTimeout(animTimer); animTimer = null; } }

    function goTo(i) {
      if (i === index) return; // 同一位置ならアニメ不要
      index = i;
      animating = true;
      setX(true);
      syncUI();
      // transitionend が来ない場合の保険
      if (animTimer) clearTimeout(animTimer);
      animTimer = setTimeout(finishTransition, 550);
    }
    function next() { if (!animating) goTo(index + 1); }
    function prev() { if (!animating) goTo(index - 1); }

    function finishTransition() {
      clearAnim();
      if (index >= realCount + 1) { index = 1; setX(false); }
      else if (index <= 0) { index = realCount; setX(false); }
    }

    track.addEventListener('transitionend', function (e) {
      if (e.target !== track || e.propertyName !== 'transform') return;
      finishTransition();
    });

    // ─ スワイプ(1枚ずつ)
    var startX = 0, startY = 0, dx = 0, dragging = false, decided = false, horizontal = false;
    function down(x, y) {
      if (animating) return;
      dragging = true; decided = false; horizontal = false;
      startX = x; startY = y; dx = 0;
      track.style.transition = 'none';
    }
    function move(x, y, e) {
      if (!dragging) return;
      dx = x - startX;
      var dy = y - startY;
      if (!decided && (Math.abs(dx) > 8 || Math.abs(dy) > 8)) {
        decided = true;
        horizontal = Math.abs(dx) > Math.abs(dy);
      }
      if (decided && horizontal) {
        if (e && e.cancelable) e.preventDefault(); // 横ドラッグ中はページ縦スクロールを抑止
        track.style.transform = 'translateX(' + (-index * slideW + dx) + 'px)';
      }
    }
    function up() {
      if (!dragging) return;
      dragging = false;
      if (!horizontal) { return; }
      var threshold = Math.max(40, slideW * 0.15);
      if (dx <= -threshold) next();
      else if (dx >= threshold) prev();
      else { setX(true); } // しきい値未満 → 元の位置へ戻す(アニメあり、index不変なので保険タイマー不要)
    }

    track.addEventListener('touchstart', function (e) { down(e.touches[0].clientX, e.touches[0].clientY); }, { passive: true });
    track.addEventListener('touchmove', function (e) { move(e.touches[0].clientX, e.touches[0].clientY, e); }, { passive: false });
    track.addEventListener('touchend', up);
    track.addEventListener('touchcancel', up);
    track.addEventListener('dragstart', function (e) { e.preventDefault(); });

    // ─ 矢印・ドット(Dawn 側のスクロール系ハンドラより先に握って無効化)
    function bind(el, fn) {
      if (!el) return;
      el.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();
        fn();
      }, true);
    }
    bind(nextBtn, next);
    bind(prevBtn, prev);
    dots.forEach(function (d, i) { bind(d, function () { if (!animating) goTo(i + 1); }); });

    // ─ リサイズ
    var rAF;
    window.addEventListener('resize', function () {
      if (rAF) cancelAnimationFrame(rAF);
      rAF = requestAnimationFrame(function () { measure(); setX(false); });
    });

    measure();
    setX(false);
    syncUI();
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('slideshow-component.vtee-hero'), function (comp) {
      initHeroCarousel(comp);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
